import { render, staticRenderFns } from "./help-commit.vue?vue&type=template&id=2ed79b62&scoped=true&"
import script from "./help-commit.vue?vue&type=script&lang=ts&"
export * from "./help-commit.vue?vue&type=script&lang=ts&"
import style0 from "./help-commit.vue?vue&type=style&index=0&id=2ed79b62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed79b62",
  null
  
)

export default component.exports